module.exports = __webpack_public_path__ + "img/max-file-content-image-check.19055a3d.svg";